import * as actionTypes from "./actionTypes";

import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";

import { getUserData, updateUserData } from "../../utils/localStorage";
import messages from "../../constants/messages";
import { parseDateToLocal, parseDateToUTC } from "../../utils/parseDateTime";
// eslint-disable-next-line
import axios from "../../axios";
import api from "../../services/index";
import { uploadFileToS3 } from "./index";
import constants from "../../constants";

import { updatePatientDoseSpotProfile } from ".";

export const setPatientPersonalInfo = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PATIENT_PERSONAL_INFO,
      payload,
    });
};

export const addAllergy = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_ALLERGIES,
    });
};

export const removeAllergy = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_ALLERGIES,
      payload: { index },
    });
};

export const addMedicalCondition = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_MEDICAL_CONDITION,
    });
};

export const removeMedicalCondition = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_MEDICAL_CONDITION,
      payload: { index },
    });
};

export const addMedication = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_MEDICATION,
    });
};

export const setMedication = (type, data, index) => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_MEDICATION,
      payload: { type, data, index },
    });
};

export const removeMedication = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_MEDICATION,
      payload: { index },
    });
};

export const addPreviousSurgery = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_PREVIOUS_SURGERY,
    });
};

export const setPreviousSurgery = (type, data, index) => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PREVIOUS_SURGERY,
      payload: { type, data, index },
    });
};

export const removePreviousSurgery = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_PREVIOUS_SURGERY,
      payload: { index },
    });
};

export const addFamilyMedicalHistory = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_FAMILY_MEDICAL_HISTORY,
    });
};

export const removeFamilyMedicalHistory = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_FAMILY_MEDICAL_HISTORY,
      payload: { index },
    });
};

export const addCurrentMedicationTimes = data => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_CURRENT_MEDICATION_TIME,
      payload: { data },
    });
};

export const addMedicationTimes = (type, data, index) => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_MEDICATION_TIME,
      payload: { type, data, index },
    });
};

export const addMedicalRecord = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_MEDICAL_RECORD,
    });
};

export const setMedicalRecord = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_MEDICAL_RECORD,
      payload,
    });
};

export const removeMedicalRecord = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_MEDICAL_RECORD,
      payload: { index },
    });
};

export const setContactDetails = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_CONTACT_DETAILS,
      payload,
    });
};

export const removeContactDetails = index => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_CONTACT_DETAILS,
      payload: { index },
    });
};

export const updateUserId = id => {
  return dispatch => {
    updateUserData({
      id,
    });
    dispatch({
      type: actionTypes.AUTH_SUCCESS,
    });
  };
};

export const savePatientDetails = cb => {
  return (dispatch, getState) => {
    const personalPatientDetails = getState().onboarding.patientPersonalInfo;
    const medical_condition = [];
    const family_medical_history = [];
    const surgery_details = [];
    const medication_details = [];
    const allergy = [];

    if (personalPatientDetails.allergy?.length > 0) {
      personalPatientDetails.allergy.forEach(all => {
        allergy.push(all);
      });
    }

    if (personalPatientDetails.medical_condition?.length > 0) {
      personalPatientDetails.medical_condition.forEach(med => {
        medical_condition.push(med);
      });
    }

    if (personalPatientDetails.family_medical_history?.length > 0) {
      personalPatientDetails.family_medical_history.forEach(family => {
        family_medical_history.push(family);
      });
    }

    if (personalPatientDetails.surgery_details?.length > 0) {
      personalPatientDetails.surgery_details.forEach(surgery =>
        surgery.surgery_name
          ? surgery_details.push({
              surgery_name: surgery.surgery_name,
              surgery_date: parseDateToUTC(surgery.surgery_date),
            })
          : ""
      );
    }

    if (personalPatientDetails.medication_details?.length > 0) {
      personalPatientDetails.medication_details.forEach(medication =>
        medication.medicine_name
          ? medication_details.push({
              medicine_name: medication.medicine_name,
              consumption: medication.consumption,
              medicine_consumption_period:
                medication.medicine_consumption_period,
              dosage: medication.dosage,
              instruction: medication.instruction,
            })
          : ""
      );
    }

    const height_value = personalPatientDetails.current_inches.label
      ? `${personalPatientDetails.current_feets.label}${personalPatientDetails.current_inches.label}`
      : `${personalPatientDetails.current_feets.label}`;

    const payload = {
      gender: personalPatientDetails.gender,
      height: height_value.replace(/\s/g, ""),
      weight: personalPatientDetails.weight,
      bmi: personalPatientDetails.bmi,
      allergy: allergy.length > 0 ? allergy : null,
      date_of_birth: parseDateToUTC(personalPatientDetails.date_of_birth),
      medical_condition:
        medical_condition.length > 0 ? medical_condition : null,
      family_medical_history:
        family_medical_history.length > 0 ? family_medical_history : null,
      surgery_details: surgery_details.length > 0 ? surgery_details : null,
      medication_details:
        medication_details.length > 0 ? medication_details : null,
      patient_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    dispatch(apiStart());

    const userPayload = {
      first_name: personalPatientDetails.firstName,
      last_name: personalPatientDetails.lastName,
    };
    api
      .updateUserInfo(getUserData().user, userPayload)
      .then(userResponse => {
        const userRes = userResponse.data;
        if (userRes.status_code === 200) {
          dispatch(apiStart());
          api
            .savePaitentInfo(payload)
            .then(response => {
              const res = response.data;
              if (res.status_code === 200) {
                dispatch(updateUserId(res.data.id));
                dispatch(getPatientDetails());
                cb();
                successHandler(messages.PERSONAL_DETAILS_ADDED_SUCCESS);
              } else {
                errorHandler(res.message[0]);
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              catchHandler(error, dispatch);
            });
        } else {
          errorHandler(userRes.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updatePatientDetails = cb => {
  return (dispatch, getState) => {
    const personalPatientDetails = getState().onboarding.patientPersonalInfo;
    const medical_condition = [];
    const family_medical_history = [];
    const new_surgery_details = [];
    const update_surgery_details = [];
    const delete_surgery_details = [];
    const new_medication_details = [];
    const update_medication_details = [];
    const delete_medication_details = [];
    const allergy = [];

    if (personalPatientDetails.allergy?.length > 0) {
      personalPatientDetails.allergy.forEach(all => {
        allergy.push(all);
      });
    }

    if (personalPatientDetails.medical_condition?.length > 0) {
      personalPatientDetails.medical_condition.forEach(med => {
        medical_condition.push(med);
      });
    }

    if (personalPatientDetails.family_medical_history?.length > 0) {
      personalPatientDetails.family_medical_history.forEach(family => {
        family_medical_history.push(family);
      });
    }

    if (personalPatientDetails.surgery_details?.length > 0) {
      personalPatientDetails.surgery_details.forEach(surgery =>
        surgery.id
          ? update_surgery_details.push({
              id: surgery.id,
              surgery_name: surgery.surgery_name,
              surgery_date: parseDateToUTC(surgery.surgery_date),
            })
          : new_surgery_details.push({
              surgery_name: surgery.surgery_name,
              surgery_date: parseDateToUTC(surgery.surgery_date),
            })
      );
    }

    if (personalPatientDetails.removedSurgeryDetails?.length > 0) {
      personalPatientDetails.removedSurgeryDetails.forEach(surgery =>
        surgery.id ? delete_surgery_details.push(surgery.id) : ""
      );
    }

    if (personalPatientDetails.medication_details?.length > 0) {
      personalPatientDetails.medication_details.forEach(medication =>
        medication.id
          ? update_medication_details.push({
              id: medication.id,
              medicine_name: medication.medicine_name,
              consumption: medication.consumption,
              medicine_consumption_period:
                medication.medicine_consumption_period,
              dosage: medication.dosage,
              instruction: medication.instruction,
            })
          : new_medication_details.push({
              medicine_name: medication.medicine_name,
              consumption: medication.consumption,
              medicine_consumption_period:
                medication.medicine_consumption_period,
              dosage: medication.dosage,
              instruction: medication.instructions,
            })
      );
    }

    if (personalPatientDetails.removedMedicationDetails?.length > 0) {
      personalPatientDetails.removedMedicationDetails.forEach(medication =>
        medication.id ? delete_medication_details.push(medication.id) : null
      );
    }
    let height_value;

    if (personalPatientDetails.current_inches.label) {
      const value = personalPatientDetails.current_inches.label
        ? `${personalPatientDetails.current_feets.label}${personalPatientDetails.current_inches.label}`
        : `${personalPatientDetails.current_feets.label}`;
      height_value = value.replace(/\s/g, "");
    } else {
      height_value = personalPatientDetails.height;
    }

    const payload = {
      gender: personalPatientDetails.gender,
      height: height_value,
      weight: personalPatientDetails.weight,
      bmi: personalPatientDetails.bmi,
      allergy: allergy.length > 0 ? allergy : null,
      patient_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      date_of_birth: parseDateToUTC(personalPatientDetails.date_of_birth),
      medical_condition:
        medical_condition.length > 0 ? medical_condition : null,
      family_medical_history:
        family_medical_history.length > 0 ? family_medical_history : null,

      //Surgery Details
      new_surgery_details:
        new_surgery_details.length > 0 ? new_surgery_details : null,
      update_surgery_details:
        update_surgery_details.length > 0 ? update_surgery_details : null,
      delete_surgery_details:
        delete_surgery_details.length > 0 ? delete_surgery_details : null,

      // Medication Details
      new_medication_details:
        new_medication_details.length > 0 ? new_medication_details : null,
      update_medication_details:
        update_medication_details.length > 0 ? update_medication_details : null,
      delete_medication_details:
        delete_medication_details.length > 0 ? delete_medication_details : null,
    };

    dispatch(apiStart());

    const userPayload = {
      first_name: personalPatientDetails.firstName,
      last_name: personalPatientDetails.lastName,
    };

    api
      .updateUserInfo(getUserData().user, userPayload)
      .then(userResponse => {
        const userRes = userResponse.data;
        if (userRes.status_code === 200) {
          dispatch(apiStart());
          api
            .updatePatientDetails(getUserData().id, payload)
            .then(response => {
              const res = response.data;
              if (res.status_code === 200) {
                // dispatch(updateUserId(res.data.id));
                dispatch(
                  getPatientDetails(false, () =>
                    personalPatientDetails?.dosespot_id
                      ? dispatch(
                          updatePatientDoseSpotProfile(
                            personalPatientDetails?.dosespot_id
                          )
                        )
                      : cb()
                  )
                );
                successHandler(messages.PERSONAL_DETAILS_SUCCESS);
              } else {
                errorHandler(res.message[0]);
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              catchHandler(error, dispatch);
            });
        } else {
          errorHandler(userRes.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getPatientDetails = (flag,cb = () => {}) => {
  return (dispatch, getState) => {
   
    
    if (flag === "init") {
      dispatch(apiStart(true));
    } else {
      dispatch(apiStart(false));
    }

    api
      .getPaitentInfo(getUserData().id,)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          if (res.data) {
            const detailsObj = res.data[0][0];
    
            updateUserData({
              firstName: detailsObj.first_name,
              lastName: detailsObj.last_name,
            });

            const pre_surgery_details = [];
            const patient_medical_records = [];

            detailsObj.patient_previous_surgeries.forEach(value =>
              pre_surgery_details.push({
                id: value.id,
                surgery_name: value.surgery_name,
                surgery_date: new Date(parseDateToLocal(value.surgery_date)),
                patient: value.patient,
              })
            );

            detailsObj.patient_medical_records.forEach(value => {
              const docName = value.document && value.document.split("/").pop();
              patient_medical_records.push({
                id: value.id,
                medical_record_name: value.medical_record_name,
                document: value.document && [
                  {
                    name: docName.substr(docName.indexOf("_") + 1),
                    src: value.document,
                  },
                ],
                record_type: value.record_type,
                examination_date: new Date(
                  parseDateToLocal(value.examination_date)
                ),
                patient_id: value.patient,
              });
            });

            let inches_feet = detailsObj.height.replace(/\s/g, "");
            var rex = /^(\d+)'(\d+)(?:''|")$/;
            var match = rex.exec(inches_feet);
            let feet, inch;
            if (match) {
              feet = match[1];
              inch = match[2];
            }

            const personalPatientDeatils = {
              photo: { src: detailsObj.image },
              firstName: getUserData().firstName,
              lastName: getUserData().lastName,
              gender: detailsObj.gender,
              height: inches_feet,
              current_feets: feet,
              current_inches: inch,
              weight: detailsObj.weight,
              bmi: detailsObj.bmi,
              date_of_birth: new Date(
                parseDateToLocal(detailsObj.date_of_birth)
              ),
              allergy: detailsObj.allergy ? detailsObj.allergy : [],
              medical_condition: detailsObj.medical_condition
                ? detailsObj.medical_condition
                : [],
              family_medical_history: detailsObj.family_medical_history
                ? detailsObj.family_medical_history
                : [],
              surgery_details: pre_surgery_details,
              medication_details: detailsObj.patient_medication_details,
              dataLoaded: true,
              dataChanged: false,
              address1: detailsObj.address1,
              address2: detailsObj.address2,
              state: detailsObj.state,
              country: detailsObj.country,
              zipcode: detailsObj.zip_code,
              city: detailsObj.city,
              primaryPhoneType: constants.PRIMARY_PHONE_TYPES.filter(
                type => type.value === detailsObj.primary_phone_type
              )[0],
              primary_phone: detailsObj.primary_phone,
              dosespot_id: detailsObj?.dosespot_id,
              currentAllergy: null,
              current_medical_condition: null,
              current_medicine_name: null,
              current_medicine_timing: null,
              current_dosage: null,
              current_instructions: null,
              current_surgery_name: null,
              current_surgery_date: null,
              current_family_medical_history: null,
              patient_timezone: detailsObj.patient_timezone,
            };

            const personalPatientInfo = {
              ...personalPatientDeatils,
              copy: personalPatientDeatils,
            };

            const medical_record = {
              medical_records: patient_medical_records,
              dataLoaded: true,
              dataChanged: false,
            };
            dispatch(setMedicalRecord(medical_record));

            dispatch(setPatientPersonalInfo(personalPatientInfo));
          }
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const savePatientDocuments = (action, cb = () => {}) => {
  return (dispatch, getState) => {
    const documents = getState().onboarding.medicalRecord;
    const new_medical_record = [];
    let image_url;
    let count = 0;

    documents.medical_records.forEach(doc => {
      uploadFileToS3(
        (doc && (doc.document[0]?.src ? undefined : doc.document[0])) ||
          undefined
      ).then(document => {
        image_url =
          (doc.document && doc?.document[0]?.src) || document.location;

        new_medical_record.push({
          patient: getUserData().id,
          medical_record_name: doc.medical_record_name,
          document: image_url,
          record_type: doc.record_type.value,
          examination_date: parseDateToUTC(doc.examination_date),
        });
        count++;
        if (documents.medical_records.length == count) {
          dispatch(apiStart());
          api
            .savePatientMedicalRecord({ data: new_medical_record })
            .then(response => {
              const res = response.data;
              if (res.status_code === 200) {
                dispatch(getPatientDetails());
                cb();
                successHandler(messages.MEDICAL_RECORD_ADDED_SUCCESS);
              } else {
                errorHandler(res.message[0]);
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              catchHandler(error, dispatch);
            });
        }
      });
    });
  };
};

export const updatePatientDocuments = (action, cb = () => {}) => {
  return (dispatch, getState) => {
    const delete_medical_record_details = [];
    const new_medical_record_details = [];
    const update_medical_record_details = [];
    let image_url;
    let count = 0;

    const documents = getState().onboarding.medicalRecord;

    if (
      documents.medical_records.length == 0 &&
      documents.removed_medical_records.length > 0
    ) {
      documents.removed_medical_records.forEach(record =>
        record.id ? delete_medical_record_details.push(record.id) : null
      );

      const payload = {
        update_medical_record_details: null,
        new_medical_record_details: null,
        delete_medical_record_details: delete_medical_record_details
          ? [...new Set(delete_medical_record_details)]
          : null,
      };

      dispatch(apiStart());
      api
        .updatePatientMedicalRecord(getUserData().id, payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            dispatch(getPatientDetails());
            cb();
            successHandler(messages.MEDICAL_RECORD_UPDATE_SUCCESS);
          } else {
            errorHandler(res.message[0]);
          }
          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    } else {
      if (documents.medical_records?.length > 0) {
        documents.medical_records.forEach(records => {
          if (records.new_record) {
            uploadFileToS3(
              (records &&
                (records.document[0]?.src ? undefined : records.document[0])) ||
                undefined
            ).then(document => {
              image_url =
                (records.document && records?.document[0]?.src) ||
                document.location;
              new_medical_record_details.push({
                document: image_url,
                medical_record_name: records.medical_record_name,
                examination_date: parseDateToUTC(records.examination_date),
                record_type: records.record_type.value,
              });
              count++;

              const payload = {
                update_medical_record_details: update_medical_record_details
                  ? update_medical_record_details
                  : null,
                new_medical_record_details: new_medical_record_details[0]
                  ? new_medical_record_details
                  : null,
                delete_medical_record_details: delete_medical_record_details
                  ? [...new Set(delete_medical_record_details)]
                  : null,
              };

              if (documents.medical_records.length == count) {
                dispatch(apiStart());
                api
                  .updatePatientMedicalRecord(getUserData().id, payload)
                  .then(response => {
                    const res = response.data;
                    if (res.status_code === 200) {
                      dispatch(getPatientDetails());
                      cb();
                      successHandler(messages.MEDICAL_RECORD_UPDATE_SUCCESS);
                    } else {
                      errorHandler(res.message[0]);
                    }
                    dispatch(apiSuccess());
                  })
                  .catch(error => {
                    catchHandler(error, dispatch);
                  });
              }
            });
          } else {
            count++;

            if (documents.removed_medical_records.length > 0) {
              documents.removed_medical_records.forEach(record =>
                record.id ? delete_medical_record_details.push(record.id) : null
              );
            }
            if (
              documents.medical_records?.length > 0 &&
              documents.removed_medical_records?.length > 0
            ) {
              if (documents.medical_records.length == count) {
                const payload = {
                  update_medical_record_details: update_medical_record_details
                    ? update_medical_record_details
                    : null,
                  new_medical_record_details: new_medical_record_details[0]
                    ? new_medical_record_details
                    : null,
                  delete_medical_record_details: delete_medical_record_details
                    ? [...new Set(delete_medical_record_details)]
                    : null,
                };

                dispatch(apiStart());
                api
                  .updatePatientMedicalRecord(getUserData().id, payload)
                  .then(response => {
                    const res = response.data;
                    if (res.status_code === 200) {
                      dispatch(getPatientDetails());
                      cb();
                      successHandler(messages.MEDICAL_RECORD_UPDATE_SUCCESS);
                    } else {
                      errorHandler(res.message[0]);
                    }
                    dispatch(apiSuccess());
                  })
                  .catch(error => {
                    catchHandler(error, dispatch);
                  });
              }
            }
          }
        });
      }
    }
  };
};

export const updatePatientContactDetails = (action, cb = () => {}) => {
  return (dispatch, getState) => {
    const personalPatientDetails = getState().onboarding.patientPersonalInfo;
    const payload = {
      address1: personalPatientDetails.address1,
      address2: personalPatientDetails.address2
        ? personalPatientDetails.address2
        : null,
      city: personalPatientDetails.city,
      state: personalPatientDetails.state,
      country: personalPatientDetails.country,
      zip_code: personalPatientDetails.zipcode,
      primary_phone: personalPatientDetails.primary_phone,
      primary_phone_type: personalPatientDetails.primaryPhoneType.value,
    };
    dispatch(apiStart());
    api
      .savePatientContactDetail(getUserData().id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(
            getPatientDetails(false, () =>
              personalPatientDetails?.dosespot_id
                ? dispatch(
                    updatePatientDoseSpotProfile(
                      personalPatientDetails?.dosespot_id
                    )
                  )
                : cb()
            )
          );
          if (action === "update") {
            successHandler(messages.CONTACT_DETAILS_SUCCESS);
          } else {
            successHandler(messages.CONTACT_ADDED_DETAILS_SUCCESS);
          }
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};
export const setPatients = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PATIENTS,
      payload,
    });
};

